import { StringReplacePipe } from '../../../../../_helpers/_pipes/string-replace.pipe';
import { BillingSidebarComponent } from '../billing-sidebar/billing-sidebar.component';
import { CheckEmailIconSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/check-email-icon-svg/check-email-icon-svg.component';
import { NewPaymentComponent } from '../../../../forms/dynamic-forms/new-payment/new-payment.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { NewPaymentService } from '../../../../../_services/forms/new-payment/new-payment.service';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { User } from '@models/user';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, NewPaymentComponent, CheckEmailIconSvgComponent, BillingSidebarComponent, StringReplacePipe],
  selector: 'app-billing-newpayment',
  templateUrl: './billing-newpayment.component.html',
  providers: [NewPaymentService],
})
export class BillingNewpaymentComponent implements OnInit {
  alerton;
  checkingInfo: any = '';
  input: object;
  inputs: any[];
  loading: boolean;
  legalCheckbox = false;
  policyId: string;
  user: User;
  showMessage = false;
  policyDetails: any;
  billingData: any;
  invalidRouting: any;
  isAcmic = false;

  constructor(
    private service: NewPaymentService,
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private acmicService: AcmicService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.isAcmic = this.acmicService.isACMIC();

    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe(
        (policyResponse) => {
          if (policyResponse) {
            this.policyDetails = policyResponse;
            this.loading = false;
          }
        },
        () => {
          this.loading = false;
        }
      );

      /*
      Don't remove just yet

      this.bankAccountService.getBankAccountByEmail(this.storageServiceObservablesService.getUserFromStorage())
      .subscribe((checkingInfo) => {
        this.checkingInfo = checkingInfo;
      });

      this.billingDetailsService.getCurrentBillByPolicy(this.policyId).subscribe((billingResponse)=>{
        this.billingData = billingResponse[0];
      });

      this.paymentDataServiceService.$policyData.
      // this.policyDetailsService.getPoliciesByEmail(this.storageServiceObservablesService.getUserFromStorage()).
      pipe(map((policyResponse: any) => {
        if(policyResponse) {
          return policyResponse.filter(
            (policy) => policy.policynumber.policyNumber == this.policyId)
        }
      })).
      subscribe((policyResponse) => {
        if (policyResponse) { this.policy = policyResponse[0]; }
      });
      */
    });
    this.inputs = this.service.getInputs(this.policyId);
  }
}
